import React from "react";

function MsThCard() {
  return (
    <>
      <div>
          <div className="">
            <img
              className=" "
              src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1682583778/physio_03_1_obcuot.jpg"
            ></img>
          </div>
          <div className="w-full">
            <h1 className="font-[700] text-[15px] text-[#56afdf] my-5 ">
              We provide Physical Therapy services
            </h1>
         
            <p className="text-[#999] text-[14px] font-[400] leading-[1.50rem]">
              When you are ready for discharge, you will receive a personalized
              home  exercise program to allow you to stay healthy exercise program to allow you to stay health on the job,
              further enhance your rehabilitation.
            </p>
          </div>
      </div>
    </>
  );
}

export default MsThCard;
